import jsPDF from 'jspdf';

const generateCirurgiaPDF = (data) => {
  const doc = new jsPDF();

  // Configuração e estilo básico do PDF
  doc.setFontSize(12);
  doc.text('Pedido de Cirurgia', 20, 20);

  // Adicionando os dados ao PDF
  doc.text(`Nome do Paciente: ${data.nomePaciente}`, 20, 30);
  doc.text(`Clínica: ${data.clinica}`, 20, 40);
  doc.text(`Diagnóstico: ${data.diagnostico}`, 20, 50);
  doc.text(`Indicação Cirúrgica: ${data.indicacaoCirurgia}`, 20, 60);
  doc.text(`Tipo de Cirurgia: ${data.tipoCirurgia}`, 20, 70);
  doc.text(`Data da Cirurgia: ${data.dataCirurgia}`, 20, 80);
  doc.text(`Local da Cirurgia: ${data.localCirurgia}`, 20, 90);
  doc.text(`Anestesista: ${data.anestesista}`, 20, 100);
  doc.text(`Equipamento Necessário: ${data.equipamentoNecessario}`, 20, 110);
  if (data.observacoes) {
    doc.text(`Observações: ${data.observacoes}`, 20, 120);
  }

  // Salvando o PDF com um nome que inclui o nome do paciente
  doc.save(`Pedido_Cirurgia_${data.nomePaciente}.pdf`);
};

export default generateCirurgiaPDF;
